import {
  Component,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

import * as Prism from 'prismjs';

enum TYPE_CSS {
  SUCCESS = 'check',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'ban',
}

@Component({
  selector: 'app-cla-alert',
  templateUrl: './cla-alert.component.html',
  styleUrls: ['./cla-alert.component.css'],
})
export class ClaAlertComponent implements AfterViewInit {
  @Input() type: String;
  @Input() message: String;
  @Input() title: String;
  @Input() typeCss: String;
  @Input() public id: string;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onClose = new EventEmitter();
  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  close() {
    this.onClose.emit(this.id);
  }

  constructor() {}
}
